<script src="../../../../../../ab站点备份/index.js"></script>
<template>
  <div ref="root" v-loading='loading'>

    <el-card>
      <el-table
        :data="st"
        border
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000'}"
        style="width: 50%;display:inline-block;border: 1px solid #000000">
        <el-table-column
          prop="wls"
          label="物流商">
        </el-table-column>
        <el-table-column
          prop="mdg"
          label="目的国">
        </el-table-column>
        <el-table-column
          prop="gjqd"
          label="国际渠道">
        </el-table-column>
        <el-table-column
          prop="sldh"
          label="示例单号">
        </el-table-column>
      </el-table>
        <el-table
          :data="wsy"
          border
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000'}"
          style="width: 50%;display:inline-block;vertical-align:top;border: 1px solid #000000">
          <el-table-column
            prop="wls"
            label="物流商">
          </el-table-column>
          <el-table-column
            prop="mdg"
            label="目的国">
          </el-table-column>
          <el-table-column
            prop="gjqd"
            label="国际渠道">
          </el-table-column>
          <el-table-column
            prop="sldh"
            label="示例单号">
          </el-table-column>
        </el-table>
    </el-card>

    <el-card v-loading="loading">
      <el-descriptions
        title="订单详情"
        direction="vertical"
        :column="3"
        border
        :labelStyle="{border: '1px solid #000000'}"
        :contentStyle="{border: '1px solid #000000'}"
      >
        <!-- 基本信息 -->
        <el-descriptions-item label="基本信息">
          <!-- <el-button size="small" type="primary" @click="edit">编辑</el-button> -->
          <!-- 店铺 -->
          <div class="big">
            <div>店铺:</div>
            <div>{{Data.site}}</div>
          </div>
          <!-- 订单id -->
          <div class="big">
            <div>订单id:</div>
            <div>{{Data.ID_}}</div>
          </div>
          <!-- 平台状态 -->
          <div class="big">
            <div>平台状态:</div>
            <div>{{Data.status}}</div>
          </div>
          <!-- 下单时间 -->
          <div class="big">
            <div>下单时间:</div>
            <div>{{Data.date_created_gmt}}</div>
          </div>
          <!-- 物流方式 -->
          <div class="big">
            <div>物流方式:</div>
            <div>{{Data.shiptype}}</div>
          </div>
          <!-- 客户备注 -->
          <div class="big">
            <div>客户备注:</div>
            <div>{{Data.customer_note}}</div>
          </div>
          <!-- 国际物流单号 -->
          <div class="big">
            <div>国际物流单号:</div>
            <div>{{Data.int_no}}</div>
          </div>

        </el-descriptions-item>
        <!-- 交易信息 -->
        <el-descriptions-item label="交易信息">
          <!-- 订单金额 -->
          <div class="big">
            <div>订单金额:</div>
            <div>{{Data.total}}</div>
          </div>
          <!-- 运费金额 -->
          <div class="big">
            <div>运费金额:</div>
            <div>{{Data.shipping_total}}</div>
          </div>
          <!-- 币种 -->
          <div class="big">
            <div>币种:</div>
            <div>{{Data.currency}}</div>
          </div>
          <!-- 交易号 -->
          <div class="big">
            <div>交易号:</div>
            <div>{{Data.transaction_id}}</div>
          </div>
          <!-- 优惠金额 -->
          <div class="big">
            <div>优惠金额:</div>
            <div>{{Data.discount_total}}</div>
          </div>
          <!-- 付款方式 -->
          <div class="big">
            <div>付款方式:</div>
            <div>{{Data.payment_method}}</div>
          </div>
        </el-descriptions-item>
        <!-- 配送信息 -->
        <el-descriptions-item label="配送信息">
          <!-- 收件人 -->
          <div class="big">
            <div>收件人:</div>
            <div>{{Data.name}}</div>
          </div>
          <!-- 邮箱 -->
          <div class="big">
            <div>邮箱:</div>
            <div>{{Data.email}}</div>
          </div>
          <!-- 省/州 -->
          <div class="big">
            <div>省/州:</div>
            <div>{{Data.state}}</div>
          </div>
          <!-- 邮编 -->
          <div class="big">
            <div>邮编:</div>
            <div>{{Data.postcode}}</div>
          </div>
          <!-- 地址 -->
          <div class="big">
            <div>地址:</div>
            <div>{{Data.address}}</div>
          </div>
          <!-- 电话 -->
          <div class="big">
            <div>电话:</div>
            <div>{{Data.phone}}</div>
          </div>
          <!-- 国家 -->
          <div class="big">
            <div>国家:</div>
            <div>{{Data.country}}</div>
          </div>
          <!-- 城市 -->
          <div class="big">
            <div>城市:</div>
            <div>{{Data.city}}</div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card v-loading="loading" class="box">
      <p style="display:inline-block; margin-right: 20px;">订购商品</p>
      <el-button size="small" type="primary" style="display:inline-block" @click="confirm">发货</el-button>
      <!-- <el-button size="small" type="primary" style="display:inline-block" @click="PlxgGjwldh">批量修改国际物流单号</el-button> -->

        <el-table
          :row-style="{height:'100px'}"
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000'}"
          :data="arr"
          @selection-change="selectionChange"
          border
          style="width: 100%;border: 1px solid #000000">

          <!-- 全选按钮 -->
          <el-table-column
            align="center"
            type="selection"
            label="全选"
            width="40px">
          </el-table-column>

          <!-- SKU -->
          <el-table-column prop="sku" label="SKU" width="120">
          </el-table-column>

          <!-- 图片 -->
          <el-table-column label="图片" width="70px">
            <template slot-scope="scope">
              <el-popover placement="right" width="500" trigger="click">
                <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
                <img :src="scope.row.img" alt="暂无图片" width="50px" height="50px" slot="reference">
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column label="图片" width="120px">
            <template slot-scope="scope">
              <img :src="scope.row.img" alt="暂无图片" width="100px">
            </template>
          </el-table-column> -->

          <!-- 商品id -->
          <el-table-column
            prop="product_id"
            label="商品id"
            align="center"
            width='140px'>
          </el-table-column>

          <!-- 名称 -->
          <el-table-column prop="product_name" label="名称" width="200px">
          </el-table-column>

          <!-- 定制信息 -->
          <el-table-column label="定制信息" >
            <template slot-scope="scope">
              <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
              <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
              <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
              <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="定制信息" width="200px">
            <template slot-scope="scope">
              <div>尺码:{{scope.row.size}}</div>
              <div>配件:{{scope.row.accessories}}</div>
              <div>袖标:{{scope.row.armband}}</div>
              <div>字号:{{scope.row.word_no == "null" ? "无" : scope.row.word_no}}</div>
            </template>
          </el-table-column> -->

          <!-- 袖标 -->
          <el-table-column label="袖标" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.armband" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" style="background:gray" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="48px" height="48px"
                      style="margin:1px;background:gray"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 配件 -->
          <el-table-column label="配件" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.accessories" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="50px" height="50px"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 数量 -->
          <el-table-column prop="quantity" label="数量" width="50px">
          </el-table-column>

          <!-- 商品备注 -->
          <el-table-column label="商品备注" width="100px">
              <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
          </el-table-column>

          <!-- 商品状态 -->
          <el-table-column prop="product_status" label="状态" width="130px">
            <template slot-scope="scope">
              <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                <el-button
                  :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '仓库已发货' ? 'success' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : ''))))))))))"
                  size="mini">
                    {{scope.row.product_status}}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <!-- 单价 -->
          <el-table-column prop="price" label="单价" width="100px">
          </el-table-column>

          <!-- 国际物流单号 -->
          <el-table-column prop="int_no" label="国际物流单号" width="140">
          </el-table-column>

          <!-- 操作 编辑 -->
          <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
              <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="edit_(scope.$index, scope.row)"
                  circle>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <span>您确认要发货吗?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="send_">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="发货方式" :visible.sync="outerVisible">
          <el-dialog
            width="50%"
            title="发货信息"
            :visible.sync="innerVisible"
            append-to-body>
            <el-form :model="form">

              <el-form-item label="站点" :label-width="formLabelWidth">
                <el-input v-model="form.site" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="订单id" :label-width="formLabelWidth">
                <el-input v-model="form.ID_" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="国际物流单号" :label-width="formLabelWidth">
                <el-input v-model="form.int_no" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="商品id" :label-width="formLabelWidth">
                <el-input v-model="form.product_ID" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="姓名" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_name" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="地址" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_address" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="电话" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_telephone" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="国家" :label-width="formLabelWidth">
                <el-input v-model="form.country" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="省/州" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_state" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="城市" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_city" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="邮编" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_postcode" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="邮箱" :label-width="formLabelWidth">
                <el-input v-model="form.consignee_email" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="客户id" :label-width="formLabelWidth">
                <el-input v-model="form.customer_id" autocomplete="off" disabled></el-input>
              </el-form-item>

              <el-form-item label="登录人id" :label-width="formLabelWidth">
                <el-input v-model="form.customer_userid" autocomplete="off" disabled></el-input>
              </el-form-item>

              <el-form-item label="原单号" :label-width="formLabelWidth">
                <el-input v-model="form.order_customerinvoicecode" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="运输渠道" :label-width="formLabelWidth">
                <el-input v-model="form.product_id" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="总重量" :label-width="formLabelWidth">
                <el-input v-model="form.weight" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="客户备注" :label-width="formLabelWidth">
                <el-input v-model="form.sku_code" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="申报总价值" :label-width="formLabelWidth">
                <el-input v-model="form.invoice_amount" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="件数" :label-width="formLabelWidth">
                <el-input v-model="form.invoice_pcs" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="品名" :label-width="formLabelWidth">
                <el-input v-model="form.invoice_title" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="中文品名" :label-width="formLabelWidth">
                <el-input v-model="form.invoice_title_cn" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="海关编码" :label-width="formLabelWidth">
                <el-input v-model="form.hs_code" autocomplete="off"></el-input>
              </el-form-item>

                <div style="display: flex; justify-content: center;">
                  <el-button @click="innerVisible = false">取 消</el-button>
                  <el-button type="primary" @click="QRFS">确认发货</el-button>
                </div>
            </el-form>
          </el-dialog>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ST_">世通</el-button>
            <el-button type="primary" @click="WSY_">威速易</el-button>
            <el-button type="primary" @click="XBH_">鑫佰航</el-button>
            <el-button type="primary" @click="HBT_">海贝通</el-button>
            <el-button @click="outerVisible = false">取 消</el-button>
          </div>
        </el-dialog>

        <el-dialog title="商品详情" :visible.sync="dialogFormVisible">
          <el-form :model="form_">

            <el-form-item label="站点" :label-width="formLabelWidth">
              <el-input v-model="form_.site" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item label="订单id" :label-width="formLabelWidth">
              <el-input v-model="form_.ID_" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item label="商品id" :label-width="formLabelWidth">
              <el-input v-model="form_.product_id" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item label="国际物流单号" :label-width="formLabelWidth">
              <el-input v-model="form_.int_no" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="QRBJ">确 定</el-button>
          </div>
        </el-dialog>

        <!-- <el-dialog title="国际物流单号" :visible.sync="GUOHAO">
          <el-form :model="formm">
            <el-form-item label="国际物流单号" :label-width="formLabelWidth">
              <el-input v-model="formm.int_no" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="GUOHAO = false">取 消</el-button>
            <el-button type="primary" @click="GUOHAO = false">确 定</el-button>
          </div>
        </el-dialog> -->

    </el-card>

    <el-card>
        <!-- height="230" -->
      <el-table
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
        :data="wlinfo"
        border
        style="border: 1px solid #000000;width: 100%">

            <!-- 国际物流单号 -->
            <el-table-column
            prop="int_no"
            label="国际物流单号"
            width="140">
            </el-table-column>

            <!-- 店铺 -->
            <el-table-column
            prop="site"
            label="店铺"
            width="120">
            </el-table-column>

            <!-- 订单id -->
            <el-table-column
            prop="ID_"
            label="订单id"
            width="80">
            </el-table-column>

            <!-- 订单状态 -->
            <el-table-column
            prop="status"
            label="订单状态"
            width="80">
            </el-table-column>

            <!-- 付款时间 -->
            <el-table-column
            prop="date_paid_gmt"
            label="付款时间"
            width='100'>
            </el-table-column>

            <!-- 发货时间 -->
            <el-table-column
            prop="created_at"
            label="发货时间"
            width='100'>
            </el-table-column>

            <!-- 物流信息最新更新时间 -->
            <el-table-column
            prop="update_date"
            label="物流信息最新更新时间"
            width='100'>
            </el-table-column>

            <!-- 目的国 -->
            <el-table-column
            prop="destination"
            label="目的国"
            width='50'>
            </el-table-column>

            <!-- 物流方式 -->
            <el-table-column
            prop="shiptype"
            label="物流方式"
            width='70'>
            </el-table-column>

            <!-- 包裹状态 -->
            <el-table-column
            prop="delivery_status"
            label="包裹状态"
            width='100'>
            </el-table-column>

            <!-- 包裹子状态 -->
            <el-table-column
            prop="substatus"
            label="包裹子状态"
            width='150'>
            </el-table-column>

            <!-- 运输时长 -->
            <el-table-column
            prop="transit_time"
            label="运输时长"
            width='50'>
            </el-table-column>

            <!-- 最近物流信息 -->
            <el-table-column
            prop="latest_event"
            label="最近物流信息">
            </el-table-column>

            <!-- 物流周期 -->
            <el-table-column
            prop="ciclo"
            label="物流周期"
            width='50'>
            </el-table-column>

            <!-- 来源地信息 -->
            <el-table-column
            prop=""
            label="来源地信息"
            width='50'>
                    Olatest_detail
                <template slot-scope="scope">
                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="LY(scope.$index, scope.row)"
                    circle
                    plain
                    ></el-button>
                </template>
            </el-table-column>

            <!-- 目的地信息 -->
            <el-table-column
            prop=""
            label="目的地信息"
            width='50'>
            Dlatest_detail
                <template slot-scope="scope">
                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="MD(scope.$index, scope.row)"
                    circle
                    plain
                    ></el-button>
                </template>
            </el-table-column>

            <!-- 停留时长 -->
            <el-table-column
            prop="stay_time"
            label="停留时长"
            width='50'>
            </el-table-column>

            <!-- 物流商简码 -->
            <el-table-column
            prop="courier_code"
            label="物流商简码"
            width='100'>
            </el-table-column>

            <!-- <el-table-column label="前往" width="50px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-position"
                  @click="look(scope.$index, scope.row)"
                  circle
                  plain
                >
                </el-button>
              </template>
            </el-table-column> -->

        </el-table>
    </el-card>

    <el-card>
      <el-table
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
        :data="jl"
        border
        style="border: 1px solid #000000;width: 100%">

        <el-table-column
            prop="product_id"
            label="商品id"
            align="center">
        </el-table-column>


        <el-table-column
            prop="product_status"
            label="商品状态"
            align="center">
        </el-table-column>


        <el-table-column
            prop="time"
            label="时间"
            align="center">
        </el-table-column>


        <el-table-column
            prop="person"
            label="操作者"
            align="center">
        </el-table-column>

      </el-table>
    </el-card>

    <!-- 来源地信息对话框 -->
    <el-dialog
        title="来源地信息"
        :visible.sync="dialogVisiblE"
        width="30%"
        :before-close="handleClosE">
        <div class="block">
            <div class="radio">
                排序：
                <el-radio-group v-model="reverse">
                <el-radio :label="true">倒序</el-radio>
                <el-radio :label="false">正序</el-radio>
                </el-radio-group>
            </div>

            <el-timeline :reverse="reverse">
                <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :timestamp="activity.tracking_detail">
                {{activity.checkpoint_date}} {{activity.location}}
                </el-timeline-item>
            </el-timeline>
        </div>
    </el-dialog>

    <!-- 目的地信息对话框 -->
    <el-dialog
        title="目的地信息"
        :visible.sync="dialogVisible_"
        width="30%"
        :before-close="handleClose_">
        <div class="block">
            <div class="radio">
                排序：
                <el-radio-group v-model="reverse_">
                <el-radio :label="true">倒序</el-radio>
                <el-radio :label="false">正序</el-radio>
                </el-radio-group>
            </div>

            <el-timeline :reverse="reverse_">
                <el-timeline-item
                    v-for="(activity, index) in activities_"
                    :key="index"
                    :timestamp="activity.tracking_detail">
                {{activity.checkpoint_date}} {{activity.location}}
                </el-timeline-item>
            </el-timeline>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import { getOD_,Send, getProduct_, Send_, Send_wsy, Send_xbh,Send_hbt, editIntNo, sswlgj, hqjl,postcode } from '../../api/api'
export default {
  data() {
    return {

      jl:[],

      dialogVisiblE:false,
      dialogVisible_:false,
      // GUOHAO:false,
      reverse: true,
      reverse_: true,
      activities: [],
      activities_: [],

      st:[
        {
          wls:'世通',
          mdg:'西班牙',
          gjqd:'广州国际线下E邮宝',
          sldh:'LVxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'西班牙',
          gjqd:'DHL专线-F',
          sldh:'CHxxxxxxxxxDE'
        },
        {
          wls:'世通',
          mdg:'西班牙',
          gjqd:'欧洲专线小包',
          sldh:'LYxxxxxxxxxDE'
        },
        {
          wls:'世通',
          mdg:'西班牙',
          gjqd:'荷兰小包普货',
          sldh:'LSxxxxxxxxxNL'
        },
        {
          wls:'世通',
          mdg:'美国',
          gjqd:'广州国际线下E邮宝',
          sldh:'LRxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'美国',
          gjqd:'美国快捷小包-F',
          sldh:'AGxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'加拿大',
          gjqd:'武汉小包',
          sldh:'RGxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'加拿大',
          gjqd:'荷兰小包普货',
          sldh:'LSxxxxxxxxxNL'
        },
        {
          wls:'世通',
          mdg:'加拿大',
          gjqd:'广州国际E特快',
          sldh:'EVxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'意大利，葡萄牙',
          gjqd:'欧洲专线小包',
          sldh:'LYxxxxxxxxxDE'
        },
        {
          wls:'世通',
          mdg:'挪威',
          gjqd:'荷兰小包普货',
          sldh:'LSxxxxxxxxxNL'
        },
        {
          wls:'世通',
          mdg:'科威特',
          gjqd:'广州国际E特快',
          sldh:'EVxxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'法国',
          gjqd:'武汉小包',
          sldh:'LExxxxxxxxxCN'
        },
        {
          wls:'世通',
          mdg:'哥伦比亚',
          gjqd:'荷兰小包普货',
          sldh:'RUxxxxxxxxxNL'
        },
        {
          wls:'世通',
          mdg:'克罗地亚',
          gjqd:'荷兰小包普货',
          sldh:'LSxxxxxxxxxNL'
        },
        {
          wls:'世通',
          mdg:'英国',
          gjqd:'英国专线小包-F',
          sldh:'WB166649862GB'
        },
      ],

      wsy:[
        {
          wls:'威速易',
          mdg:'法国',
          gjqd:'E邮宝广州-普货',
          sldh:'LVxxxxxxxxxCN'
        },
        {
          wls:'威速易',
          mdg:'日本',
          gjqd:'E邮宝广州-普货',
          sldh:'LPxxxxxxxxxCN'
        },
        {
          wls:'威速易',
          mdg:'英国',
          gjqd:'专线-欧洲小包(H)',
          sldh:'WBxxxxxxxxxGB'
        },
        {
          wls:'威速易',
          mdg:'美国',
          gjqd:'E邮宝广州-普货',
          sldh:'LRxxxxxxxxxCN'
        },
        {
          wls:'威速易',
          mdg:'德国',
          gjqd:'专线-欧洲小包(H)',
          sldh:'RSxxxxxxxxxDE'
        },
        {
          wls:'威速易',
          mdg:'西班牙',
          gjqd:'专线-欧洲DHL小包(H)',
          sldh:'CAxxxxxxxxxDE'
        },
        {
          wls:'威速易',
          mdg:'荷兰',
          gjqd:'专线-欧洲DHL小包(H)',
          sldh:'CAxxxxxxxxxDE'
        },
        {
          wls:'威速易',
          mdg:'巴西',
          gjqd:'武汉小包',
          sldh:'RGxxxxxxxxxCN'
        },
        {
          wls:'威速易',
          mdg:'瑞士',
          gjqd:'E特快-广州',
          sldh:'EVxxxxxxxxxCN'
        },,
        {
          wls:'世通',
          mdg:`日本客户邮编号 0-520开头,935-999开头`,
          gjqd:'在这个邮编号范围内的客户，不能下EUB',
          sldh:''
        },
      ],

      dialogFormVisible:false,
      formLabelWidth: '120px',
      form_:{
        site:'',
        ID_:'',
        product_id:'',
        int_no:'',
        int_no_:''
      },

      form: {
        site:'',
        ID_:'',
        int_no:'',
        product_ID:'',
        consignee_name:'',
        consignee_address:'',
        consignee_telephone:'',
        country:'',
        consignee_state:'',
        consignee_city:'',
        consignee_postcode:'',
        consignee_email:'',
        customer_id:'',
        customer_userid:'',
        product_id:'',
        weight:'',
        invoice_amount:'',
        invoice_pcs:'',
        invoice_title:'',
        invoice_title_cn:'',
        sku_code:'',
        hs_code:''
      },//发货信息

      // formm: {
      //   site:'',
      //   ID_:'',
      //   product_id:'',
      //   int_no:'',
      //   int_no_:''
      // },
      formLabelWidth: '100px',
      outerVisible: false,
      innerVisible: false,
      dialogVisible: false,
      Data: {},//订单详情
      loading: true,
      senddata: [],//发货商品
      arr: [],//订购商品
      wlinfo: [],//物流信息
      codes:[]
    };
  },
  created() {
    var un = window.localStorage.getItem('un');
    if(un == '' || un == null || un == undefined){
      this.loading = false;
      return false;
    }

    var site_ = this.$route.query.site;
    var ID_ = this.$route.query.ID_;
    var postcode_ = 33209;
    var params = {
      site_:this.$route.query.site,
      ID_:this.$route.query.ID_,
      postcode_ : 33209
    }
    //获取单个订单
  this.loading = true;
   //获取postcode 以判断渠道
     // postcode(params).then(res => {
        // console.log(res);
       // this.Data = res[0];
        // for(var i of res){
        //   if(i.site == site_ && i.ID_ == ID_){
        //     this.Data = i;
        //     // this.tableData = JSON.parse(i.line_items);
        //   }
        // }
        // console.log(this.Data);
        // this.loading = false;

        // 搜索物流轨迹
       // var cs = this.Data.postcode;
        // console.log(cs);
      //  sswlgj(cs).then(res => {
          // console.log(res);
       //   this.codes = res;
      //  })

     // })
  getOD_(params)
    .then(res => {
      this.Data = res[0] || {};
      console.log('✅ 赋值成功', this.Data);

      const cs = this.Data.int_no;
      if (cs) {
        return sswlgj(cs).then(res => {
          this.wlinfo = res;
        });
      }
    })
    .catch(err => {
      console.error('订单加载失败:', err);
    })
    .finally(() => {
      this.loading = false; // 保证在所有异步完成后才隐藏 loading
    });


    //获取单个订单中的所有商品
    var params = {
      site:site_,
      ID:ID_,
      postcode:this.Data.postcode
    }
    getProduct_(params).then(res => {
      for (const i of res) {
        if(i.armband == null || i.armband == undefined || i.armband == ''){
          i.armband = '无';
        }
        else if(i.armband.charAt(0) == "h"){
          i.armband = i.armband.split(",");
        }

        if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
          i.accessories = '无';
        }
        else if(i.accessories.charAt(0) == "h"){
          i.accessories = i.accessories.split(",");
        }
      }
      this.arr = res;
      var www = [];
      for(var i of res){
        www.push(i.product_id);
      }
      // console.log(www);
      hqjl(www).then(res => {
        this.jl = res;
      })
      this.loading = false;
    })

    // 搜索物流轨迹
    // var cs = this.Data.int_no;
    // sswlgj(cs).then(res => {

    // })
  },
  methods: {
         generateReferenceNo() {
            const prefix = 'HY';
            const randomNumber = Math.floor(Math.random() * 1e10).toString().padStart(10, '0');
            return prefix + randomNumber;
          },
    // 查看来源地信息
    LY(index,row) {
        this.dialogVisiblE = true;
        this.activities = JSON.parse(row.Olatest_detail)[0].trackinfo;
    },

    // 关闭来源地信息
    handleClosE() {
        this.dialogVisiblE = false;
    },

    // 查看目的地信息
    MD(index,row) {
        this.dialogVisible_ = true;
        this.activities_ = JSON.parse(row.Dlatest_detail)[0].trackinfo;
    },

    // 关闭目的地信息
    handleClose_() {
        this.dialogVisible_ = false;
    },

    // // 编辑国际物流单号
    // edit(){
    //   this.dialogFormVisible = true;
    // },

    // 确认编辑国际物流单号
    QRBJ(){
      for(var i of this.arr){
        if(i.product_id == this.form_.product_id){
          i.int_no = this.form_.int_no;
        }
      }
      var intNo_arr = [];
      // 将单个订单里的所有商品的商品id组合为一个新数组
      for(var i of this.arr){
        intNo_arr.push(i.int_no);
      }
      // console.log(intNo_arr);
      // 将新数组去重
      var newIntNo_arr = [...new Set(intNo_arr)];
      // console.log(newIntNo_arr);
      var end_ = newIntNo_arr.toString();
      // console.log(end_);
      var params = {
        site: this.form_.site,
        ID_: this.form_.ID_,
        product_id: this.form_.product_id,
        int_no: this.form_.int_no,
        int_no_:end_
      }
      // console.log(params);
      editIntNo(params).then(res => {});
      this.dialogFormVisible = false;
    },

    // 编辑国际物流单号
    edit_(index,row){
      this.form_ = {
        site: this.$route.query.site,
        ID_: this.$route.query.ID_,
        product_id: row.product_id,
        int_no: row.int_no,
        int_no_:''
      }
      this.dialogFormVisible = true;
      // console.log(index,row);
    },

    //复选框
    selectionChange(selection) {
      this.senddata = selection;
      // console.log(selection[0].int_no);
    },

    // X(发货)
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    //点击发货(二次确认)
    confirm(){
      // this.dialogVisible = true;
      if(this.senddata.length == 0){
        this.$message({
          message:"请先选择要发货的商品！！！",
          type:"error"
        })
        return false;
      }else{
        this.outerVisible = true;
      }
    },

    // PlxgGjwldh(){
    //   if(this.senddata.length == 0){
    //     this.$message({
    //       message:"请先选择要修改国际物流单号的商品！！！",
    //       type:"error"
    //     })
    //     return false;
    //   }else{
    //     this.GUOHAO = true;
    //     this.formm.site = this.arr[0].site;
    //     this.formm.ID_ = this.arr[0].ID_;
    //     var product_ID_Arr = [];
    //     for(var YYY of this.senddata){
    //       product_ID_Arr.push(YYY.product_id);
    //     }
    //     this.formm.product_id = product_ID_Arr;
    //     console.log(product_ID_Arr);
    //     console.log(this.senddata);
    //     console.log(this.arr);
    //     console.log(this.formm);
    //   }
    // },

    //点击确认(确认发货) 初始方法
    send_(){
      this.dialogVisible = false;
      console.log(this.senddata);
      //未选择发货的商品
      if(this.senddata.length == 0){
        this.$message({
          message:"请先选择要发货的商品！！！",
          type:"error"
        })
        return false;
      }else if(this.senddata.length != 0){
        if(this.Data.shiptype == '包邮' || this.Data.shiptype == 'EMS' || this.Data.shiptype == '佐川'){
          for(var u of this.senddata){
            if(u.int_no != "" && u.int_no != null && u.int_no != undefined){
              this.$message({
                message:'您选中的商品中存在已经发过货的商品，不能二次发货！！！',
                type:'error'
              })
              return false;
            }
          }
          var a = 0;
          for(var i of this.senddata){
            a += i.quantity;
          }
          var count = a.toString();
          var total = (3 * a).toString();
          if(this.Data.country == "BE" || this.Data.country == "BG" || this.Data.country == "CZ" || this.Data.country == "DK" || this.Data.country == "DE" || this.Data.country == "EE" || this.Data.country == "IE" || this.Data.country == "EL" || this.Data.country == "ES" || this.Data.country == "FR" || this.Data.country == "HR" || this.Data.country == "IT" || this.Data.country == "CY" || this.Data.country == "LV" || this.Data.country == "LT" || this.Data.country == "LU" || this.Data.country == "HU" || this.Data.country == "MT" || this.Data.country == "NL" || this.Data.country == "AT" || this.Data.country == "PL" || this.Data.country == "PT" || this.Data.country == "RO" || this.Data.country == "SI" || this.Data.country == "SK" || this.Data.country == "FI" || this.Data.country == "SE"){
            var now = new Date();
            var original_number = now.getTime().toString();
            var sss = [];
            for(var t = 0;t < this.senddata.length;t++){
              sss.push(this.senddata[t].product_id);
            }
            console.log(sss);
            if(this.Data.int_no == '' || this.Data.int_no == null || this.Data.int_no == undefined){
              this.Data.int_no = '';
            }
            // "customer_id": "52061","customer_userid": "48321", 线上
            // "customer_id": "52401","customer_userid": "48661", 测试
            var params = {
                "site": this.senddata[0].site,
                "ID_": this.senddata[0].ID_,
                "int_no": this.Data.int_no,
                "product_ID": sss,
                "consignee_name": this.Data.name,
                "consignee_address": this.Data.address,
                "consignee_telephone": this.Data.phone,
                "country": this.Data.country,
                "consignee_state": this.Data.state,
                "consignee_city": this.Data.city,
                "consignee_postcode": this.Data.postcode,
                "customer_id": "52061",
                "customer_userid": "48321",
                "order_customerinvoicecode": this.senddata[0].ID_ + "-" + original_number,
                "product_id": "9321",
                "weight": "100",
                "orderInvoiceParam": [
                    {
                      "invoice_amount": total,
                      "invoice_pcs": count,
                      "invoice_title": "T-shirt",
                      "invoice_title_cn": "",
                      "hs_code": "6109100010"
                    }
                ]
            };
            Send(params).then(res => {}).catch(error => {
              console.log(error);
            });
            // for(var j = 0; j < this.arr.length; j++){
            //   for(var i = 0; i < this.senddata.length; i++){
            //     if(this.senddata[i].site == this.arr[j].site && this.senddata[i].ID_ == this.arr[j].ID_){
            //       this.senddata[i].product_status = "物流已发货";
            //     }
            //   }
            // }
          }else if(this.Data.country != "BE" && this.Data.country != "BG" && this.Data.country != "CZ" && this.Data.country != "DK" && this.Data.country != "DE" && this.Data.country != "EE" && this.Data.country != "IE" && this.Data.country != "EL" && this.Data.country != "ES" && this.Data.country != "FR" && this.Data.country != "HR" && this.Data.country != "IT" && this.Data.country != "CY" && this.Data.country != "LV" && this.Data.country != "LT" && this.Data.country != "LU" && this.Data.country != "HU" && this.Data.country != "MT" && this.Data.country != "NL" && this.Data.country != "AT" && this.Data.country != "PL" && this.Data.country != "PT" && this.Data.country != "RO" && this.Data.country != "SI" && this.Data.country != "SK" && this.Data.country != "FI" && this.Data.country != "SE"){
            var now = new Date();
            var original_number = now.getTime().toString();
            var sss = [];
            for(var t = 0;t < this.senddata.length;t++){
              sss.push(this.senddata[t].product_id);
            }
            console.log(sss);
            if(this.Data.int_no == '' || this.Data.int_no == null || this.Data.int_no == undefined){
              this.Data.int_no = '';
            }
            var params = {
                "site": this.senddata[0].site,
                "ID_": this.senddata[0].ID_,
                "int_no": this.Data.int_no,
                "product_ID": sss,
                "consignee_name": this.Data.name,
                "consignee_address": this.Data.address,
                "consignee_telephone": this.Data.phone,
                "country": this.Data.country,
                "consignee_state": this.Data.state,
                "consignee_city": this.Data.city,
                "consignee_postcode": this.Data.postcode,
                "customer_id": "52061",
                "customer_userid": "48321",
                "order_customerinvoicecode": this.senddata[0].ID_ + "-" + original_number,
                "product_id": "11141",
                "weight": "100",
                "orderInvoiceParam": [
                    {
                      "invoice_amount": total,
                      "invoice_pcs": count,
                      "invoice_title": "T-shirt",
                      "invoice_title_cn": "",
                      "hs_code": "6109100010"
                    }
                ]
            };
            Send(params).then(res => {}).catch(error => {
              console.log(error);
            });
            // for(var j = 0; j < this.arr.length; j++){
            //   for(var i = 0; i < this.senddata.length; i++){
            //     if(this.senddata[i].site == this.arr[j].site && this.senddata[i].ID_ == this.arr[j].ID_){
            //       this.senddata[i].product_status = "物流已发货";
            //     }
            //   }
            // }
          }
        }else if(this.Data.shiptype != '包邮' && this.Data.shiptype != 'EMS' && this.Data.shiptype != '佐川'){
          this.$message({
            message:'物流方式不是(包邮,EMS,佐川),不能进行发货。',
            type:'error'
          })
        }
      }
    },

    // ST(信息展示)
    ST_(){
        this.innerVisible = true;
        this.form.site = this.Data.site;                                            //站点
        this.form.ID_ = this.Data.ID_;                                              //订单id
        this.form.int_no = this.Data.int_no;                                        //国际物流单号
          var sss = [];
          for(var t = 0;t < this.senddata.length;t++){
            sss.push(this.senddata[t].product_id);
          }
        this.form.product_ID = sss.toString();                                       //商品id
        this.form.consignee_name = this.Data.name;                                   //姓名
        this.form.consignee_address = this.Data.address;                             //地址
        this.form.consignee_telephone = this.Data.phone;                             //电话
        this.form.country = this.Data.country;                                       //国家
        this.form.consignee_state = this.Data.state;                                 //省/州
        this.form.consignee_city = this.Data.city;                                   //城市
        this.form.consignee_postcode = this.Data.postcode;                           //邮编
        this.form.consignee_email = this.Data.email;                                 //邮箱
        // "customer_id": "52061","customer_userid": "48321", 线上
        // "customer_id": "52401","customer_userid": "48661", 测试
        this.form.customer_id = '52061';                                             //客户id
        this.form.customer_userid = '48321';                                         //登录人id
          var now = new Date();
         // var original_number = now.getTime().toString();
         // 获取时间戳并除以10，去掉小数部分
         let timestampPart = Math.floor(now.getTime() / 10).toString();

         // 如果ID是6位数，则再除以10去掉一位
         if (this.Data.ID_ && this.Data.ID_.toString().length === 6) {
             timestampPart = Math.floor(parseInt(timestampPart) / 10).toString();
         }

         // 组合成最终的单号
         this.form.order_customerinvoicecode = this.Data.ID_ + '-' + timestampPart;
      /**
       * EMS，包邮
       *
       * BE 比利时
       * LU 卢森堡
       * DK 丹麦
       * GR 希腊
       * AT 奥地利
       * SE 瑞典
       * FI 芬兰
       * HU 匈牙利
       * EE 爱沙尼亚
       * LT 立陶宛
       * MT 马耳他
       * SK 斯洛伐克
       * SI 斯洛文尼亚
       * RO 罗马尼亚
       *
       * 广州线下E邮宝-IOSS 9321
       * 欧洲小众专线-F  ：12621
       * '12261';//广州线下E邮宝
       */
      if((
        this.Data.country == "BE" ||
        this.Data.country == "LU" ||
        this.Data.country == "DK" ||
        this.Data.country == "GR" ||
        this.Data.country == "AT" ||
        this.Data.country == "SE" ||
        this.Data.country == "FI" ||
        this.Data.country == "HU" ||
        this.Data.country == "EE" ||
        this.Data.country == "LT" ||
        this.Data.country == "MT" ||
        this.Data.country == "SK" ||
        this.Data.country == "SI" ||
        this.Data.country == "RO") && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype =='Free shipping(79)'
        || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '12261';//广州线下E邮宝
        if(this.Data.country == "BE"){
         // this.form.product_id = '12681';//欧洲七国
           this.form.product_id = '4181';  //NL-欧洲小包-M
        }
      }

      /**
       * EMS，包邮
       *
       * BE 比利时
       * HU 匈牙利
       * AT 奥地利
       * DK 丹麦
       * BR 巴西
       * DHL-F快速 12561
       * 、
       *
       *
       * DHL-F 8621
       * 欧洲小众专线-F  ：12621
       */
      if((
          this.Data.country == "BE" ||
          this.Data.country == "DK" ||
          this.Data.country == "AT" ||
          this.Data.country == "HU" ||
          this.Data.country == "BR") && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
            if(this.Data.country == "BE"){
               // this.form.product_id = '12681';//欧洲七国
                 this.form.product_id = '4181';  //NL-欧洲小包-M
            }else {
                this.form.product_id = '8621';//DHL-F快速
            }
                                                       //运输渠道
      }
      /**
       *
       *
       * FR 法国 GB 英国 所有订单
       *
       * 英欧专线AT-F : 11621
       */

    // else if(this.Data.country == "GB"){
     //   this.form.product_id = '1761';//1761 英国专线皇邮
    //  }
    //  else if(this.Data.country == "FR"){
     //   this.form.product_id = '12061';
    //  }

       else if(this.Data.country == "GB"){
       console.log(this.Data.shiptype)
             // this.form.product_id = '12681';//1761 英国专线皇邮
               this.form.product_id = '4181';  //NL-欧洲小包-M
            }
            else if(this.Data.country == "FR"){
             // this.form.product_id = '12681';
               this.form.product_id = '4181';  //NL-欧洲小包-M
            }
      /**
       * EMS，包邮
       *
       * GB 英国
       *
       * 英国皇家邮政-F 11061
       */

      // else if(this.Data.country == "GB" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮')){
      //   this.form.product_id = '11061';
      // }


      /**
       * EMS，包邮
       *
       * NL 荷兰
       *
       * 欧洲专线小包-荷兰 7181
       * 欧洲小众专线-F  ：12621
       */

      else if(this.Data.country == "NL" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '12561';//DHL
      }

      /**
       * 所有订单
       *
       * DE 德国
       *
       *  11621
       */

      else if(this.Data.country == "DE"){
       // this.form.product_id = '12681'; //欧洲七国
         this.form.product_id = '4181';  //NL-欧洲小包-M
      }

      /**
       * EMS，包邮
       *
       * IE 爱尔兰
       *
       * DHL-F快速12561
       * DHL-F 8621
       * 欧洲小众专线-F  ：12621
       */

      else if(this.Data.country == "IE" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        //this.form.product_id = '12621';
         this.form.product_id = '4181';  //NL-欧洲小包-M
      }


      /**
       * EMS，包邮
       *
       * PL 波兰
       *
       * 欧洲专线小包-波兰 12041
       * 欧洲小众专线-F  ：12621
       */

      else if(this.Data.country == "PL" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮')){
       // this.form.product_id = '12621';
         this.form.product_id = '4181';  //NL-欧洲小包-M
      }

      /**
       *
       * CH 瑞士
       *
       * 英欧专线AT-F 11621
       * 欧洲小众专线-F  ：12621
       */

      else if(this.Data.country == "CH"){
      //  this.form.product_id = '12621';
         this.form.product_id = '4181';  //NL-欧洲小包-M
      }

      /**
       * DHL,DHL慢
       *
       * PT 葡萄牙
       *
       * DHL专线-F 8621
       */
      else if(this.Data.country == "PT" && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '12201'; //西班牙葡萄牙专线-F 12201
      }


      /**
       * DHL，DHL慢
       *
       * LU 卢森堡
       * DK 丹麦
       * GR 希腊
       * EE 爱沙尼亚
       * LV 拉脱维亚
       * LT 立陶宛
       * SI 斯洛文尼亚
       * BG 保加利亚
       * HR 克罗地亚
       * RO 罗马尼亚
       *
       * 欧洲专线小包-F 7041
       * DHL专线-F快速 8621
       * 欧洲小众专线-F  ：12621
       */
      else if((
        this.Data.country == "LU" ||
        this.Data.country == "DK" ||
        this.Data.country == "GR" ||
        this.Data.country == "EE" ||
        this.Data.country == "LV" ||
        this.Data.country == "LT" ||
        this.Data.country == "SI" ||
        this.Data.country == "BG" ||
        this.Data.country == "HR" ||
        this.Data.country == "RO") && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
          this.form.product_id = '8621';
      }

      /**
       * DHL，DHL慢
       *
       * SK 斯洛伐克
       * PL 波兰
       * IE 爱尔兰
       * BE 比利时
       * SE 瑞典
       * AT 奥地利
       *
       *
       *
       * 欧洲小众专线-F  ：12621
       * */
      else if((
          (
          this.Data.country == "SK" ||
          this.Data.country == "PL" ||
          this.Data.country == "IE" ||
          this.Data.country == "BE" ||
          this.Data.country == "SE" ||
          this.Data.country == "AT"
          )
          &&
          (
          this.Data.shiptype == "DHL" ||
          this.Data.shiptype == "DHL慢"
          )
        )){
          if(this.Data.country == "BE"){
           // this.form.product_id = '12681'; //欧洲七国
             this.form.product_id = '4181';  //NL-欧洲小包-M
          }
         // this.form.product_id = '12621';
           this.form.product_id = '4181';  //NL-欧洲小包-M
        }

      /**
       * DHL，DHL慢
       *
       * CZ 捷克
       * CY 塞浦路斯
       * IN 印度
       * NL 荷兰
       * HU 匈牙利
       * AR 阿根廷
       * MX 墨西哥
       * AE 阿联酋
       * FI 芬兰
       *
       * 广州国际E特快 12241
       * 欧洲小众专线-F  ：12621
       * */
      else if((
          this.Data.country == "CZ" ||
          this.Data.country == "CY" ||
          this.Data.country == "IN" ||
          this.Data.country == "NL" ||
          this.Data.country == "HU" ||
          this.Data.country == "AR" ||
          this.Data.country == "MX" ||
          this.Data.country == "AE" ||
          this.Data.country == "FI"
          ) && (
          this.Data.shiptype == "DHL" ||
          this.Data.shiptype == "DHL慢"
          )
        ) {
          if (this.Data.country == "IN" || this.Data.country == "AR" || this.Data.country == "AE"){
            this.form.product_id = '12241';//广州国际E特快
          }else {
            this.form.product_id = '8621';
          }

        }

      /**
       * EMS，包邮
       *
       * MQ 马提尼克岛
       * BH 巴林
       * CZ 捷克
       * IS 冰岛
       * RE 留尼旺岛
       * BJ 贝宁
       * PR 波多黎各
       * PA 巴拿马
       *
       * 荷兰小包普货 10261
       * 欧洲小众专线-F  ：12621
       * */
      else if((
          this.Data.country == "MQ" ||
          this.Data.country == "BH" ||
          this.Data.country == "CZ" ||
          this.Data.country == "IS" ||
          this.Data.country == "RE" ||
          this.Data.country == "BJ" ||
          this.Data.country == "PR" ||
          this.Data.country == "PA"
          ) && (
          this.Data.shiptype == "EMS" ||
          this.Data.shiptype == "包邮"
          )
        ) {
        this.form.product_id = '10261';//DHL
        }

      /**
       * EMS，包邮
       *
       * HR 克罗地亚
       * LV 拉脱维亚
       * CY 塞浦路斯
       * BG 保加利亚
       * NO 挪威
       *
       * 欧洲小众专线-F  ：12621
       * */
      else if((
          this.Data.country == "HR" ||
          this.Data.country == "LV" ||
          this.Data.country == "CY" ||
          this.Data.country == "BG" ||
          this.Data.country == "NO"
      ) && (
          this.Data.shiptype == "EMS" ||
          this.Data.shiptype == "包邮" || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries'
      )
      ) {
       // this.form.product_id = '12621';//荷兰小包普货
         this.form.product_id = '4181';  //NL-欧洲小包-M

      }

      // 2023-03-15 (世通 => 美国,澳大利亚 EMS,包邮)
      else if((
        this.Data.country == 'US' ||
        this.Data.country == 'AU') && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '12261';//广州国际线下E邮宝
      }
      //加急运输美国
        else if((
              this.Data.country == 'US') && (this.Data.shiptype == 'Expedite Shipping: About 15-20 days for most countries')){
              this.form.product_id = '12261';//广州国际线下E邮宝
            }
      // (世通 => 美国 DHL，DHL慢 11681)
      else if(this.Data.country == 'US' && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '4601';//美国包税服装-F4601  美国USPS-F2  12501
      }
      // 2023-03-01 (日本所有订单 7661)
      else if(this.Data.country == 'JP'){
        this.form.product_id = '7661';//日本专线小包-F
      }
      // 2023-03-15 (世通 => 英国 DHL，DHL慢 11061)
      // else if(this.Data.country == 'GB' && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
      //   this.form.product_id = '11061';//英国皇家邮政-F
      // }

      /**  2023-03-20

      (世通 => EMS,包邮 =>

      MX 墨西哥，
      PE 秘鲁，
      MA 摩洛哥，
      AR 阿根廷，
      IS 冰岛，
      IN 印度，
      KW 科威特，
      CR 哥斯达黎加，
      LK 斯里兰卡，
      EC 厄瓜多尔，
      OM 阿曼)

      //广州小包 10981

      */
      else if((
        this.Data.country == 'MX' ||
        this.Data.country == 'PE' ||
        this.Data.country == 'MA' ||
        this.Data.country == 'AR' ||
        this.Data.country == 'IS' ||
        this.Data.country == 'IN' ||
        this.Data.country == 'KW' ||
        this.Data.country == 'CR' ||
        this.Data.country == 'LK' ||
        this.Data.country == 'EC' ||
        this.Data.country == 'OM') && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮')){
        this.form.product_id = '10981';//广州小包
      }

      /**  2023-03-20
       *
      (世通 => EMS,包邮 =>

      CA 加拿大，
      IL 以色列，
      SA 沙特阿拉伯，
      NO 挪威，
      BR 巴西，
      NZ 新西兰，
      CL 智利，
      SG 新加坡，
      RS 塞尔维亚，
      GE 格鲁吉亚，
      TR 土耳其，
      TH 泰国，
      KR 韩国)

      广州国际线下E邮宝 11141

      */
      else if((
        this.Data.country == 'CA' ||
        this.Data.country == 'IL' ||
        this.Data.country == 'SA' ||
        //this.Data.country == 'NO' ||
        this.Data.country == 'BR' ||
        this.Data.country == 'NZ' ||
        this.Data.country == 'CL' ||
        this.Data.country == 'SG' ||
        this.Data.country == 'RS' ||
        this.Data.country == 'GE' ||
        this.Data.country == 'TR' ||
        this.Data.country == 'TH' ||
        this.Data.country == 'KR') && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮' || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '12261';//广州线下E邮宝-YD
      }

      /**  2023-03-20

      (世通 => EMS,包邮 =>

      AE 阿联酋，
      ZA 南非，
      PR 波多黎各，
      CO 哥伦比亚，
      SM 圣马力诺，
      QA 卡塔尔，
      TT 特立尼达和多巴哥，
      UY 乌拉圭，
      BN 文莱，
      AM 亚美尼亚，
      MQ 马提尼克，
      GT 危地马拉，
      GF 法属圭亚那，
      SV 萨尔瓦多)

      荷兰小包普货 10261

      */
      else if((
        this.Data.country == 'AE' ||
        this.Data.country == 'ZA' ||
        this.Data.country == 'PR' ||
        this.Data.country == 'CO' ||
        this.Data.country == 'SM' ||
        this.Data.country == 'QA' ||
        this.Data.country == 'TT' ||
        this.Data.country == 'UY' ||
        this.Data.country == 'BN' ||
        this.Data.country == 'AM' ||
        this.Data.country == 'MQ' ||
        this.Data.country == 'GT' ||
        this.Data.country == 'GF' ||
        this.Data.country == 'SV') && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮'
        || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '10261';//荷兰小包普货
      }

      // 2023-03-20 (世通 => DHL,DHL慢 => 挪威) 欧洲小众专线-F  ：12621
      else if(this.Data.country == 'NO' && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢'
      || this.Data.shiptype == 'Free shipping(79)' || this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '8621';
      }

      /**  2023-03-20

      (世通 => DHL,DHL慢 =>

      AU 澳大利亚，
      CA 加拿大，
      IL 以色列，
      SA 沙特阿拉伯，
      ZA 南非，
      PE 秘鲁，
      MA 摩洛哥，
      BR 巴西，
      NZ 新西兰，
      CO 哥伦比亚，
      KW 科威特，
      SG 新加坡，
      QA 卡塔尔，
      TR 土耳其，
      UY 乌拉圭，
      TH 泰国，
      LK 斯里兰卡，
      KR 韩国)

      广州国际E特快 12241

      */
      else if((
        this.Data.country == 'AU' ||
        this.Data.country == 'CA' ||
        this.Data.country == 'IL' ||
        this.Data.country == 'SA' ||
        this.Data.country == 'ZA' ||
        this.Data.country == 'PE' ||
        this.Data.country == 'MA' ||
        this.Data.country == 'BR' ||
        this.Data.country == 'NZ' ||
        this.Data.country == 'CO' ||
        this.Data.country == 'KW' ||
        this.Data.country == 'SG' ||
        this.Data.country == 'QA' ||
        this.Data.country == 'TR' ||
        this.Data.country == 'UY' ||
        this.Data.country == 'TH' ||
        this.Data.country == 'LK' ||
        this.Data.country == 'KR') && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '12241';//广州国际E特快
      }
    else if((
        this.Data.country == 'CA') && (this.Data.shiptype == 'Standard Shipping: About 20-25 days for most countries')){
        this.form.product_id = '12241';//广州国际E特快
      }
      /**  2023-03-20 (
       世通 => DHL,DHL慢 =>

       CH 瑞士，
       CL 智利，
       CR 哥斯达黎加)

       广州国际EMS 12221
       欧洲小众专线-F  ：12621
       */
      else if((
        //this.Data.country == 'CH' ||
        this.Data.country == 'CL' ||
        this.Data.country == 'CR') && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '8621';//欧洲小众专线-F
      }

      /**
       * EMS，包邮
       *
       * ES 西班牙
       *
       * PT 葡萄牙
       *
       * 西班牙葡萄牙专线AQ-F 11201
       */

      else if(this.Data.country == "ES" && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '12201'; //DHL专线-F
      }
      else if(this.Data.country == "ES" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮')){
        this.form.product_id = '12201'; //DHL专线-F
      }
      else if(this.Data.country == "PT" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮')){
        this.form.product_id = '12201';
      }
      /**
       *
       * 世通所有渠道
       *
       * IT 意大利
       *
       * 欧洲专线小包-意大利 12042
       * 英欧专线AT-F  11621
       */


      else if(this.Data.country == 'IT'){
        //this.form.product_id = '12681';//欧洲七国
         this.form.product_id = '4181';  //NL-欧洲小包-M
      }
      else if((this.Data.country == "SE" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮'))){
        this.form.product_id = '8621';//欧洲小众专线-F                                            //运输渠道
      }
      else if(this.Data.country == "MT" && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '8621';//DHL专线-F快速 8621
      }
      else if(this.Data.country == "GR" && (this.Data.shiptype == 'DHL' || this.Data.shiptype == 'DHL慢')){
        this.form.product_id = '8621';//DHL专线-F快速 8621
      }
      else if((this.Data.country == "GR" && (this.Data.shiptype == 'EMS' || this.Data.shiptype == '包邮'))){
        this.form.product_id = '12261';//欧洲小众专线-F                                            //运输渠道
      }
      else{
        this.form.product_id = '';
        this.$message({
          message:'没有匹配到相应的运输渠道,请先检查运输渠道!!!',
          type:'warning'
        })
         console.log(this.Data.shiptype )
          console.log(this.Data.country )
        console.log('没有匹配到相应的运输渠道')
      }
     // console.log(this.form.product_id )
      if(this.Data.country == 'FR' || this.Data.country == 'DE' || this.Data.country == "GB" || this.Data.country == "CH"){
        this.form.weight = '0.1';
      }else{
        this.form.weight = '0.1';                                                      //总重量
      }
      if(this.Data.customer_note == '()'){
        this.form.sku_code = '';                                                     //客户备注
      }else{
        this.form.sku_code = this.Data.customer_note;                                //客户备注
      }
          var a = 0;
          for(var i of this.senddata){
            a += i.quantity;
          }
          var count = a.toString();
          var total = (3 * a).toString();
        this.form.invoice_amount = total;                                            //申报总价值
        if(this.form.country == 'ES' && count > 4){
          this.form.invoice_pcs = 4
        }else{
          this.form.invoice_pcs = count;                                             //件数
        }
        this.form.invoice_title = 'T-shirt';                                         //品名
        this.form.hs_code = '6109100010';                                            //海关编码

    },

    // WSY(信息展示)
    WSY_(){
      this.innerVisible = true;
          // console.log(this.Data);
        this.form.site = this.Data.site;                                            //站点
        this.form.ID_ = this.Data.ID_;                                              //订单id
        this.form.int_no = this.Data.int_no;                                        //国际物流单号
          var sss = [];
          for(var t = 0;t < this.senddata.length;t++){
            sss.push(this.senddata[t].product_id);
          }
          // console.log(sss);
        this.form.product_ID = sss.toString();                                       //商品id
        this.form.consignee_name = this.Data.name;                                   //姓名
        this.form.consignee_address = this.Data.address;                             //地址
        this.form.consignee_telephone = this.Data.phone;                             //电话
        this.form.country = this.Data.country;                                       //国家
        this.form.consignee_state = this.Data.state;                                 //省/州
        this.form.consignee_city = this.Data.city;                                   //城市
        this.form.consignee_postcode = this.Data.postcode;                           //邮编
        this.form.consignee_email = this.Data.email;                                 //邮箱
        this.form.customer_id = '548953';                                            //客户id
        this.form.customer_userid = '543353';                                        //登录人id
          var now = new Date();
          var original_number = now.getTime().toString();
        this.form.order_customerinvoicecode = this.Data.ID_ + '-' + original_number; //原单号
      // 11.16(威速易 => 法国 EMS，包邮 3121)
      // if(this.Data.country == "FR" && (this.Data.shiptype == "EMS" || this.Data.shiptype == "包邮")){
      //   this.form.product_id = "3121";
      // }
      // 福建EUB特货 日本所有订单
      // else
      if(this.Data.country == 'JP'){
        this.form.product_id = '13057';
      }
      if(this.Data.country == 'GR'){
        this.form.product_id = '12261';console.log(this.form.product_id)
      }
      else{
        this.form.product_id = '';
        this.$message({
          message:'没有匹配到相应的运输渠道,请先检查运输渠道!!!',
          type:'warning'
        })
      }
        this.form.weight = '100';                                                    //总重量
      if(this.Data.customer_note == '()'){
        this.form.sku_code = '';                                                     //客户备注
      }else{
        this.form.sku_code = this.Data.customer_note;                                //客户备注
      }
          var a = 0;
          for(var i of this.senddata){
            a += i.quantity;
          }
          var count = a.toString();
          var total = (3 * a).toString();
        this.form.invoice_amount = total;                                            //申报总价值
        this.form.invoice_pcs = count;                                               //件数
        this.form.invoice_title = 'T-shirt';                                         //品名
        this.form.hs_code = '6109100010';                                            //海关编码
    },

    // XBH(信息展示)
    XBH_(){
      this.innerVisible = true;
        this.form.site = this.Data.site;                                            //站点
        this.form.ID_ = this.Data.ID_;                                              //订单id
        this.form.int_no = this.Data.int_no;                                        //国际物流单号
          var sss = [];
          for(var t = 0;t < this.senddata.length;t++){
            sss.push(this.senddata[t].product_id);
          }
        this.form.product_ID = sss.toString();                                       //商品id
        this.form.consignee_name = this.Data.name;                                   //姓名
        this.form.consignee_address = this.Data.address;                             //地址
        this.form.consignee_telephone = this.Data.phone;                             //电话
        this.form.country = this.Data.country;                                       //国家
        this.form.consignee_state = this.Data.state;                                 //省/州
        this.form.consignee_city = this.Data.city;                                   //城市
        this.form.consignee_postcode = this.Data.postcode;                           //邮编
        this.form.consignee_email = this.Data.email;                                 //邮箱
        // 暂时关闭
        this.form.customer_id = '16581';                                             //客户id
        this.form.customer_userid = '13041';                                         //登录人id
          var now = new Date();
          var original_number = now.getTime().toString();
        this.form.order_customerinvoicecode = this.Data.ID_ + '-' + original_number; //原单号
       // if(this.Data.country == "ES"){
                   //   this.form.product_id = '4821';//西班牙 英欧专线AT-F  11621
             //  }

             if(this.Data.country == "PT" || this.Data.country == "ES" || this.Data.country == "PL"){
               this.form.product_id = '4841';//欧洲5国专线
             }
            else if(this.Data.country == "IT"){
              this.form.product_id = '4901';//意大利 邮政小包F
            }
             else if(this.Data.country == "FR"){
               this.form.product_id = '4861';//法国
             }
             else if(this.Data.country == "DE"){
                  this.form.product_id = '1881';//欧洲DHL专线-F价
             }
             else if(this.Data.country == "GB"){
               this.form.product_id = '4821';//英国专线小包
             }
             else if(this.Data.country == "JP"){
               this.form.product_id = '3381';//日本
             }
              else if(this.Data.country == "US"){
                               this.form.product_id = '2621';//美国
              }
        else{
          this.form.product_id = '2781';//全球
          // this.$message({
          //   message:'没有匹配到相应的运输渠道,请先检查运输渠道!!!',
          //   type:'warning'
          // })
        }
        if(this.Data.customer_note == '()'){
          this.form.sku_code = '';                                                     //客户备注
        }else{
          this.form.sku_code = this.Data.customer_note;                                //客户备注
        }
          var a = 0;
          for(var i of this.senddata){
            a += i.quantity;
          }
          var count = a.toString();
          this.form.weight = count * 0.25;                                                      //总重量
          // var total = (3 * a).toString();
        this.form.invoice_amount = 11;                                            //申报总价值
        if(count > 5){
          this.form.invoice_pcs = 5;
        }else{
          this.form.invoice_pcs = count;                                               //件数
        }
        this.form.invoice_title = 'T-shirt';                                         //品名
        this.form.hs_code = '6109100010';                                            //海关编码
    },

     // HBT(信息展示)
        HBT_(){
          this.innerVisible = true;
             console.log(this.Data);
            this.form.site = this.Data.site;                                            //站点
            this.form.ID_ = this.Data.ID_;                                              //订单id
            this.form.int_no = this.Data.int_no;                                        //国际物流单号
              var sss = [];
              for(var t = 0;t < this.senddata.length;t++){
                sss.push(this.senddata[t].product_id);
              }

            this.form.product_ID = sss.toString();                                       //商品id
            this.form.consignee_name = this.Data.name;                                   //姓名
            this.form.consignee_address = this.Data.address;                             //地址
            this.form.consignee_telephone = this.Data.phone;                             //电话
            this.form.country = this.Data.country;                                       //国家
            this.form.consignee_state = this.Data.state;                                 //省/州
            this.form.consignee_city = this.Data.city;                                   //城市
            this.form.consignee_postcode = this.Data.postcode;                           //邮编
            this.form.consignee_email = this.Data.email;                                 //邮箱
            // 暂时关闭
            this.form.customer_id = '121415';                                             //客户id
            this.form.customer_userid = '121314';                                         //登录人id
              var now = new Date();
              var original_number = now.getTime().toString();
            this.form.order_customerinvoicecode = this.Data.ID_ + '-' + original_number; //原单号
             if(this.Data.country == "US"){
                   this.form.product_id = 'HX152';//USPS美国专线小包-普货
                    }else if(this.Data.country == "PL"){
                     this.form.product_id = 'HX044';//欧洲渠道
                    }else{
                    this.form.product_id = 'HX021';//广州E邮宝
                    }
            if(this.Data.customer_note == '()'){
              this.form.sku_code = '';                                                     //客户备注
            }else{
              this.form.sku_code = this.Data.customer_note;                                //客户备注
            }
              var a = 0;
              for(var i of this.senddata){
                a += i.quantity;
              }
              var count = a.toString();
              this.form.weight = count * 0.25;                                                      //总重量
             var total = (3 * a).toString();
             this.form.invoice_amount = total;                                              //申报总价值
            if(count > 5){
              this.form.invoice_pcs = 5;
            }else{
              this.form.invoice_pcs = count;                                               //件数
            }
            this.form.invoice_title = 'T-shirt';                                         //品名
            this.form.invoice_title_cn = '';
            this.form.hs_code = '6109100010';                                            //海关编码
        },


    //(确认发货)
    QRFS(){

      for(var u of this.senddata){
        if(u.int_no != "" && u.int_no != null && u.int_no != undefined){
          this.$message({
            message:'您选中的商品中存在已经发过货的商品，不能二次发货！！！',
            type:'error'
          })
          return false;
        }
      }
      // 世通
      if(this.form.customer_id == "52061"){
        if(this.form.product_id != '9321'){
          var params = {
            "site": this.form.site,
            "ID_": this.form.ID_,
            "int_no": this.form.int_no,
            "product_ID": this.form.product_ID.split(','),
            "consignee_name": this.form.consignee_name,
            "consignee_address": this.form.consignee_address,
            "consignee_telephone": this.form.consignee_telephone,
            "country": this.form.country,
            "consignee_state": this.form.consignee_state,
            "consignee_city": this.form.consignee_city,
            "consignee_postcode": this.form.consignee_postcode,
            "consignee_email": this.form.consignee_email,
            "customer_id": this.form.customer_id,
            "customer_userid": this.form.customer_userid,
            "product_id": this.form.product_id,
            "weight": this.form.weight,
            "order_customerinvoicecode":this.form.order_customerinvoicecode,
            "orderInvoiceParam": [
                {
                  "invoice_amount": this.form.invoice_amount,
                  "invoice_pcs": this.form.invoice_pcs,
                  "invoice_title": this.form.invoice_title,
                  "sku_code": this.form.sku_code,
                  "hs_code": this.form.hs_code,
                  "sku":'T恤'
                }
            ]
          };
        }else{
          var params = {
            "site": this.form.site,
            "ID_": this.form.ID_,
            "int_no": this.form.int_no,
            "product_ID": this.form.product_ID.split(','),
            "consignee_name": this.form.consignee_name,
            "consignee_address": this.form.consignee_address,
            "consignee_telephone": this.form.consignee_telephone,
            "country": this.form.country,
            "consignee_state": this.form.consignee_state,
            "consignee_city": this.form.consignee_city,
            "consignee_postcode": this.form.consignee_postcode,
            "consignee_email": this.form.consignee_email,
                  "consignee_doorno": '、',
            "customer_id": this.form.customer_id,
            "customer_userid": this.form.customer_userid,
            "product_id": this.form.product_id,
            "weight": this.form.weight,
            "order_customerinvoicecode":this.form.order_customerinvoicecode,
            "orderInvoiceParam": [
                {
                  "invoice_amount": this.form.invoice_amount,
                  "invoice_pcs": this.form.invoice_pcs,
                  "invoice_title": this.form.invoice_title,
                  "sku_code": this.form.sku_code,
                  "hs_code": this.form.hs_code,
                  "sku":'T恤'
                }
            ],
            "shipper_taxnotype":"IOSS",
            // "shipper_taxno":"IM3800013016",
            "shipper_taxnocountry":"IT"
          };
        }
        if(this.form.product_id == '' || this.form.product_id == null || this.form.product_id == undefined){
          this.$message({
            message:'运输渠道为空,完善信息后在进行发货!!!',
            type:'error'
          })
          return false;
        }

         console.log(params);
        Send_(params).then(res => {}).catch(error => {
          console.log(error);
        });
        this.innerVisible = false;
        this.outerVisible = false;
        this.$message({
          message:'发货成功！！！',
          type:'success'
        })
      }
      // 威速易
      else if(this.form.customer_id == "548953"){
        // if((this.form.country == "BE" || this.form.country == "BG" || this.form.country == "CZ" || this.form.country == "DK" || this.form.country == "DE" || this.form.country == "EE" || this.form.country == "IE" || this.form.country == "EL" || this.form.country == "ES" || this.form.country == "FR" || this.form.country == "HR" || this.form.country == "IT" || this.form.country == "CY" || this.form.country == "LV" || this.form.country == "LT" || this.form.country == "LU" || this.form.country == "HU" || this.form.country == "MT" || this.form.country == "NL" || this.form.country == "AT" || this.form.country == "PL" || this.form.country == "PT" || this.form.country == "RO" || this.form.country == "SI" || this.form.country == "SK" || this.form.country == "FI" || this.form.country == "SE") && this.Data.shiptype == "EMS"){
        //   var params = {
        //     "site": this.form.site,
        //     "ID_": this.form.ID_,
        //     "int_no": this.form.int_no,
        //     "product_ID": this.form.product_ID.split(','),
        //     "consignee_name": this.form.consignee_name,
        //     "consignee_address": this.form.consignee_address,
        //     "consignee_telephone": this.form.consignee_telephone,
        //     "country": this.form.country,
        //     "consignee_state": this.form.consignee_state,
        //     "consignee_city": this.form.consignee_city,
        //     "consignee_postcode": this.form.consignee_postcode,
        //     "customer_id": this.form.customer_id,
        //     "customer_userid": this.form.customer_userid,
        //     "product_id": this.form.product_id,
        //     "weight": this.form.weight,
        //     "order_customerinvoicecode":this.form.order_customerinvoicecode,
        //     "orderInvoiceParam": [
        //         {
        //           "invoice_amount": this.form.invoice_amount,
        //           "invoice_pcs": this.form.invoice_pcs,
        //           "invoice_title": this.form.invoice_title,
        //           "sku_code": this.form.sku_code,
        //           "hs_code": this.form.hs_code
        //         }
        //     ],
        //     "shipper_taxnotype":"IOSS",
        //     "shipper_taxno":"IM3800013016",
        //     "shipper_taxnocountry":"IT"
        //   };

        //   if(this.form.product_id == '' || this.form.product_id == null || this.form.product_id == undefined){
        //     this.$message({
        //       message:'运输渠道为空,完善信息后在进行发货!!!',
        //       type:'error'
        //     })
        //     return false;
        //   }
        //   // console.log(111);

        //   Send_wsy(params).then(res => {}).catch(error => {
        //     console.log(error);
        //   });
        //   this.innerVisible = false;
        //   this.outerVisible = false;
        //   this.$message({
        //     message:'发货成功！！！',
        //     type:'success'
        //   })
        // }else{
          var params = {
            "site": this.form.site,
            "ID_": this.form.ID_,
            "int_no": this.form.int_no,
            "product_ID": this.form.product_ID.split(','),
            "consignee_name": this.form.consignee_name,
            "consignee_address": this.form.consignee_address,
            "consignee_telephone": this.form.consignee_telephone,
            "country": this.form.country,
            "consignee_state": this.form.consignee_state,
            "consignee_city": this.form.consignee_city,
            "consignee_postcode": this.form.consignee_postcode,
            "customer_id": this.form.customer_id,
            "customer_userid": this.form.customer_userid,
            "product_id": this.form.product_id,
            "weight": this.form.weight,
            "order_customerinvoicecode":this.form.order_customerinvoicecode,
            "orderInvoiceParam": [
                {
                  "invoice_amount": this.form.invoice_amount,
                  "invoice_pcs": this.form.invoice_pcs,
                  "invoice_title": this.form.invoice_title,
                  "sku_code": this.form.sku_code,
                  "hs_code": this.form.hs_code
                }
            ]
          };

          if(this.form.product_id == '' || this.form.product_id == null || this.form.product_id == undefined){
            this.$message({
              message:'运输渠道为空,完善信息后在进行发货!!!',
              type:'error'
            })
            return false;
          }
          // console.log(111);

          Send_wsy(params).then(res => {}).catch(error => {
            console.log(error);
          });
          this.innerVisible = false;
          this.outerVisible = false;
          this.$message({
            message:'发货成功！！！',
            type:'success'
          })
      }
      // 鑫佰航
      else if(this.form.customer_id == "16581"){
        var params = {
          "site": this.form.site,
          "ID_": this.form.ID_,
          "int_no": this.form.int_no,
          "product_ID": this.form.product_ID.split(','),
          "consignee_name": this.form.consignee_name,
          "consignee_address": this.form.consignee_address,
          "consignee_telephone": this.form.consignee_telephone,
          "country": this.form.country,
          "consignee_state": this.form.consignee_state,
          "consignee_city": this.form.consignee_city,
          "consignee_postcode": this.form.consignee_postcode,
          "consignee_email": this.form.consignee_email,
          "customer_id": this.form.customer_id,
          "customer_userid": this.form.customer_userid,
          "product_id": this.form.product_id,
          "weight": this.form.weight,
          "order_customerinvoicecode":this.form.order_customerinvoicecode,
          "orderInvoiceParam": [
              {
                "invoice_amount": this.form.invoice_amount,
                "invoice_pcs": this.form.invoice_pcs,
                "invoice_title": this.form.invoice_title,
                "sku_code": this.form.sku_code,
                "hs_code": this.form.hs_code
              }
          ]
        };

        if(this.form.product_id == '' || this.form.product_id == null || this.form.product_id == undefined){
          this.$message({
            message:'运输渠道为空,完善信息后在进行发货!!!',
            type:'error'
          })
          return false;
        }
        console.log(params);
        Send_xbh(params).then(res => {}).catch(error => {
          console.log(error);
        });
        this.innerVisible = false;
        this.outerVisible = false;
        this.$message({
          message:'发货成功！！！',
          type:'success'
        })
      }else if(this.form.customer_id == "121415"){
      var params = {
        apiParams: {
          "reference_no": this.generateReferenceNo(),
          "shipping_method": this.form.product_id,
          "order_weight": this.form.weight,
          "order_pieces": 1,
          "mail_cargo_type": 4,
          "consignee": {
            "consignee_province": this.form.consignee_state,
            "consignee_city": this.form.consignee_city,
            "consignee_street": this.Data.address,
            "consignee_postcode": this.form.consignee_postcode,
            "consignee_name": this.form.consignee_name,
            "consignee_telephone": this.form.consignee_telephone,
            "consignee_countrycode": this.form.country,
            "consignee_email": this.form.consignee_email, // ✅ 去掉 "consignee." 前缀
          },
          "shipper": {
            "shipper_countrycode": "CN",
            "shipper_city": "广州市",
            "shipper_street": "京溪街道,京溪大街105号",
            "shipper_province": "广东省",
            "shipper_district": "白云区",
            "shipper_name": "李树",
            "shipper_telephone": "19126665336",
          },
          "invoice": [
            {
              "invoice_enname": this.form.invoice_title,
              "invoice_cnname": this.form.invoice_title_cn,
              "invoice_quantity": 1,
              "unit_code": "PCE",
              "invoice_unitcharge": 3.0,
              "net_weight": 0.25,
              "invoice_note": "广东省广州市白云区京溪街道,京溪大街105号"
            }
          ]
        },

        // ✅ 系统内部使用的字段
        local: {
          "site": this.form.site,
          "ID_": this.form.ID_,
          "int_no": this.form.int_no,
          "product_ID": this.form.product_ID.split(','),
        }
      };
              if(this.form.product_id == '' || this.form.product_id == null || this.form.product_id == undefined){
                this.$message({
                  message:'运输渠道为空,完善信息后在进行发货!!!',
                  type:'error'
                })
                return false;
              }
              console.log(params);
              Send_hbt(params).then(res => {}).catch(error => {
                console.log(error);
              });
              this.innerVisible = false;
              this.outerVisible = false;
              this.$message({
                message:'发货成功！！！',
                type:'success'
              })
      }
    }

  },

};
</script>

<style lang="scss" scoped>
p{
  font-weight: bolder;
  margin-bottom: 10px;
}
.big{
  div:nth-child(1){
    width: 100px;
  }
  div{
    display: inline-block;
  }
}
.box{
  .el-table{
    display: inline-block;
    vertical-align: top;
  }
}
</style>